export default {
  navbar: {
    'btn-navbar-logout': 'btn-navbar-logout',
    'img-navbar-rize_logo': 'img-navbar-rize_logo',
    'slc-navbar-user_profile': 'slc-navbar-user_profile',
    'img-navbar-user_avatar': 'img-navbar-user_avatar',
    'text-navbar-username': 'text-navbar-username',
    'text-navbar-user_role': 'text-navbar-user_role',
  },
  sidebar: {
    'btn-sidebar-dashboard': 'btn-sidebar-dashboard',
    'btn-sidebar-pipes': 'btn-sidebar-pipes',
    'btn-sidebar-pipe_review': 'btn-sidebar-pipe_review',
    'btn-sidebar-users': 'btn-sidebar-users',
    'btn-sidebar-farmers': 'btn-sidebar-farmers',
    'btn-sidebar-performance': 'btn-sidebar-performance',
    'btn-sidebar-stakeholders': 'btn-sidebar-stakeholders',
    'btn-sidebar-hotcash': 'btn-sidebar-hotcash',
    'btn-sidebar-collection-overview': 'btn-sidebar-collection-overview',
    'btn-sidebar-collection-invoice': 'btn-sidebar-collection-invoice',
    'btn-sidebar-system-utils': 'btn-sidebar-system-utils',
    'btn-sidebar-farmer-group': 'btn-sidebar-farmer-group',
    'btn-sidebar-delivery-packages': 'btn-sidebar-delivery-packages',
    'sidebar-menu': 'sidebar-menu',
    'text-sidebar-app_version': 'text-sidebar-app_version',
  },
  hotcashPage: {
    'inp-hotcash-invoice_search': 'inp-hotcash-invoice_search',
    'inp-hotcash-farmer_search': 'inp-hotcash-farmer_search',
    'slc-hotcash-agronomist': 'slc-hotcash-agronomist',
    'slc-hotcash-status': 'slc-hotcash-status',
    status: {
      'tag-hotcash-late': 'tag-hotcash-late',
      'tag-hotcash-live': 'tag-hotcash-live',
      'tag-hotcash-settled': 'tag-hotcash-settled',
    },
    table: {
      'text-hotcash-time_left_timer': 'text-hotcash-time_left_timer',
      'text-hotcash-agronomist_name': 'text-hotcash-agronomist_name',
      'text-hotcash-paid_by': 'text-hotcash-paid_by',
      'text-hotcash-cash_held': 'text-hotcash-cash_held',
      'text-hotcash-farmer_name': 'text-hotcash-farmer_name',
      'text-hotcash-invoice_number': 'text-hotcash-invoice_number',
      'text-hotcash-paddy_buyer_name': 'text-hotcash-paddy_buyer_name',
      'text-hotcash-starting_time': 'text-hotcash-starting_time',
    },
  },
  stakeholderPage: {
    'btn-stakeholder-add-paddy_buyer': 'btn-stakeholder-add-paddy_buyer',
    'btn-stakeholder-add-farmer_group_leader':
      'btn-stakeholder-add-farmer_group_leader',
    'btn-stakeholder-add-machine_owner': 'btn-stakeholder-add-machine_owner',
    'btn-stakeholder-sync-deals': 'btn-stakeholder-sync-deals',
    tabs: {
      'btn-stakeholder-tab-paddy_buyer': 'btn-stakeholder-tab-paddy_buyer',
      'btn-stakeholder-tab-farmer_group_leader':
        'btn-stakeholder-tab-farmer_group_leader',
      'btn-stakeholder-tab-machine_owner': 'btn-stakeholder-tab-machine_owner',
      'btn-stakeholder-tab-arrow_dropdown':
        'btn-stakeholder-tab-arrow_dropdown',
    },
  },
  invoiceListPage: {
    'row-invoice-filters': 'row-invoice-filters',
    'inp-invoice-search': 'inp-invoice-search',
    'rng-invoice-est-harvest-date': 'rng-invoice-est-harvest-date',
    'slc-invoice-payment-status': 'slc-invoice-payment-status',
    'slc-invoice-agronomist': 'slc-invoice-agronomist',
    'slc-invoice-sub-district': 'slc-invoice-sub-district',
    'slc-invoice-country': 'slc-invoice-country',
    'slc-invoice-season': 'slc-invoice-season',
  },
};
